;(function() {
  'use strict'

  angular.module('core.linkList', [])
})()
